import { isNumber, isString } from '../helpers/strict-type-checks';
/**
 * Check if a time value is a business day object.
 *
 * @param time - The time to check.
 * @returns `true` if `time` is a {@link BusinessDay} object, false otherwise.
 */
export function isBusinessDay(time) {
    return !isNumber(time) && !isString(time);
}
/**
 * Check if a time value is a UTC timestamp number.
 *
 * @param time - The time to check.
 * @returns `true` if `time` is a {@link UTCTimestamp} number, false otherwise.
 */
export function isUTCTimestamp(time) {
    return isNumber(time);
}
export function isWhitespaceData(data) {
    return (data.open === undefined &&
        data.value === undefined);
}
export function isFulfilledData(data) {
    return (data.open !== undefined ||
        data.value !== undefined);
}
